import { useCallback } from "react"
import { authStore } from "@/store/auth"

import { stopImpersonation as stopImpersonationAction } from "../actions/hijack-actions"

export function useImpersonation() {
  const isImpersonating = authStore(s => s.isImpersonating)
  const impersonatorId = authStore(s => s.impersonatorId)
  const impersonatedUser = authStore(s => (s.isImpersonating ? s.user : null))

  const stopImpersonation = useCallback(() => {
    stopImpersonationAction()
    // Hard redirect to avoid stale React state after switching user session
    window.location.href = "/admin/users"
  }, [])

  return {
    isImpersonating,
    impersonatorId,
    impersonatedUser,
    stopImpersonation,
  }
}
